import axios from 'axios'
axios.defaults.baseURL = 'https://agrotrack.moozistudio.com/api/'

axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem('access')

export default axios.create({

})
